import { makeDefaultApi } from './request';
import { I18nText } from '../i18n_text';

export interface DocumentCategoryData {
  id?: string;
  name_json: I18nText;
}

interface DocumentCategoryRequestParams {
  ids?: string[];
  /** A serialised QtFilterModel — see `main/document_categories/list_query.py` for the fields. */
  filter?: string;
  /** Sort keys, outermost first, `-` prefixed for descending. */
  sort?: string[];
}

export const { list, retrieve, save, remove } = makeDefaultApi<
  DocumentCategoryData,
  DocumentCategoryRequestParams
>('document_categories');
